import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import PrimeVue from 'primevue/config'; 
import Aura from '@primevue/themes/aura';
import Menubar from 'primevue/menubar';
import PrimeToolbar from 'primevue/toolbar';
import PrimeBreadcrumb from 'primevue/breadcrumb';
import PrimeButton from 'primevue/button';
import PrimePanel from 'primevue/panel';
import PrimeSelectButton from 'primevue/selectbutton';

const app = createApp(App);
app.use(PrimeVue, {
    theme: {
        preset: Aura,
        options: {
            darkModeSelector: '.my-app-dark',
        }
    }
});

app.use(router);


app.component('MenuBar', Menubar)
app.component('PrimeToolbar', PrimeToolbar);
app.component('PrimeBreadcrumb', PrimeBreadcrumb);
app.component('PrimeButton', PrimeButton);
app.component('PrimePanel', PrimePanel);
app.component('PrimeSelectButton', PrimeSelectButton);



app.mount('#app');
